import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  AlertDialog as ShadcnAlertDialog,
  AlertDialogAction as ShadcnAlertDialogAction,
  AlertDialogCancel as ShadcnAlertDialogCancel,
  AlertDialogContent as ShadcnAlertDialogContent,
  AlertDialogDescription as ShadcnAlertDialogDescription,
  AlertDialogFooter as ShadcnAlertDialogFooter,
  AlertDialogHeader as ShadcnAlertDialogHeader,
  AlertDialogMedia as ShadcnAlertDialogMedia,
  AlertDialogOverlay as ShadcnAlertDialogOverlay,
  AlertDialogPortal as ShadcnAlertDialogPortal,
  AlertDialogTitle as ShadcnAlertDialogTitle,
  AlertDialogTrigger as ShadcnAlertDialogTrigger,
} from "src/shadcn/components/alert-dialog";

const AlertDialog = (props: React.ComponentProps<typeof ShadcnAlertDialog>) => (
  <ShadcnAlertDialog {...props} />
);

const AlertDialogAction = (
  props: React.ComponentProps<typeof ShadcnAlertDialogAction>
) => <ShadcnAlertDialogAction {...props} />;

const AlertDialogCancel = (
  props: React.ComponentProps<typeof ShadcnAlertDialogCancel>
) => <ShadcnAlertDialogCancel {...props} />;

const AlertDialogContent = (
  props: React.ComponentProps<typeof ShadcnAlertDialogContent>
) => <ShadcnAlertDialogContent {...props} />;

const AlertDialogDescription = (
  props: React.ComponentProps<typeof ShadcnAlertDialogDescription>
) => <ShadcnAlertDialogDescription {...props} />;

const AlertDialogFooter = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnAlertDialogFooter>) => (
  <ShadcnAlertDialogFooter
    className={cn("border-border", className)}
    {...props}
  />
);

const AlertDialogHeader = (
  props: React.ComponentProps<typeof ShadcnAlertDialogHeader>
) => <ShadcnAlertDialogHeader {...props} />;

const AlertDialogMedia = (
  props: React.ComponentProps<typeof ShadcnAlertDialogMedia>
) => <ShadcnAlertDialogMedia {...props} />;

const AlertDialogOverlay = (
  props: React.ComponentProps<typeof ShadcnAlertDialogOverlay>
) => <ShadcnAlertDialogOverlay {...props} />;

const AlertDialogPortal = (
  props: React.ComponentProps<typeof ShadcnAlertDialogPortal>
) => <ShadcnAlertDialogPortal {...props} />;

const AlertDialogTitle = (
  props: React.ComponentProps<typeof ShadcnAlertDialogTitle>
) => <ShadcnAlertDialogTitle {...props} />;

const AlertDialogTrigger = (
  props: React.ComponentProps<typeof ShadcnAlertDialogTrigger>
) => <ShadcnAlertDialogTrigger {...props} />;

export {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
};
